'use strict';

exports.__esModule = true;
exports.Icon = exports.Subtitle = exports.Title = exports.Message = exports.Header = exports.LargeWrapper = exports.BaseWrapper = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  top: 50%;\n  right: auto;\n  left: 50%;\n  width: 600px;\n  padding: 27px 36px;\n  font-size: 21px;\n  transform: translate(-50%, -50%);\n\n  @media (min-width: ', ') {\n    left: 62.5%;\n  }\n'], ['\n  top: 50%;\n  right: auto;\n  left: 50%;\n  width: 600px;\n  padding: 27px 36px;\n  font-size: 21px;\n  transform: translate(-50%, -50%);\n\n  @media (min-width: ', ') {\n    left: 62.5%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 400;\n  color: ', ';\n'], ['\n  font-weight: 400;\n  color: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('../styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var BaseWrapper = exports.BaseWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'styled__BaseWrapper'
})(['position:fixed;top:50px;right:50px;z-index:2000;width:400px;padding:1em 1.5em;background:', ';box-shadow:3px 3px 9px 1px rgba(50,50,50,0.15);'], _styles.colors.white);

var LargeWrapper = exports.LargeWrapper = BaseWrapper.extend(_templateObject, _styles.etc.screenMd);

var Header = exports.Header = _styledComponents2.default.header.withConfig({
  displayName: 'styled__Header'
})(['position:absolute;top:5px;right:12px;']);

var Message = exports.Message = _styledComponents2.default.div.withConfig({
  displayName: 'styled__Message'
})(['overflow:hidden;']);

var Title = exports.Title = _styledComponents2.default.p.withConfig({
  displayName: 'styled__Title'
})(['margin:0 0 6px;']);

var Subtitle = exports.Subtitle = Title.extend(_templateObject2, _styles.colors.grayLight);

var Icon = exports.Icon = _styledComponents2.default.div.withConfig({
  displayName: 'styled__Icon'
})(['float:left;margin-right:', ';svg{width:', ';height:', ';}path{fill:', ';}'], function (p) {
  return p.largeAlert ? '2.25em' : '1.5em';
}, function (p) {
  return p.largeAlert ? '4em' : '3.25em';
}, function (p) {
  return p.largeAlert ? '4em' : '3.25em';
}, function (p) {
  return p.color;
});


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Alert/styled.js
// module id = 683
// module chunks = 14